import Http from '@/api/http.js'

export default {

  index(filters) {
    return Http.get(`/vrt_transactions`, {
      headers: {
        filter: JSON.stringify(filters? filters : null)
      }
    
    })
  },
  defaultIndex(params){
    return Http.get(`/vrt_transactions`, { params })
  },

  show(id) {
    return Http.get(`/vrt_transactions/${id}`);
  },
  
  create(vrt_transaction){
    return Http.post(`/vrt_transactions`, {vrt_transaction: {...vrt_transaction}})
  },

  update(vrt_transaction){
    return Http.put(`/vrt_transactions/${vrt_transaction.id}`, {
      vrt_transaction: {...vrt_transaction},
    });
  },


}
